import React from "react";
import {
  AlertIcon,
  ImpactIcon,
  OpenIcon,
} from "../CustomChartComponents/CustomChartComponents";

const legendItemStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "6px",
  marginRight: "16px",
};

const iconWrapperStyle = {
  width: 28,
  height: 28,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

function ChartAlertsLegend() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        margin: "12px",
      }}
    >
      <div style={legendItemStyle}>
        <span style={iconWrapperStyle}>
          <AlertIcon fill="red" />
        </span>
        <span>Alerta de temperatura</span>
      </div>

      <div style={legendItemStyle}>
        <span style={iconWrapperStyle}>
          <ImpactIcon fill="#002E6D" />
        </span>
        <span>Alerta de impacto</span>
      </div>

      <div style={legendItemStyle}>
        <span style={iconWrapperStyle}>
          <OpenIcon fill="#002E6D" />
        </span>
        <span>Alerta de apertura</span>
      </div>
    </div>
  );
}

export default ChartAlertsLegend;
